/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
// import { AuthErrorHandler } from './auth-crypto/auth-crypto-error-handler';
// import { AuthRequestOptions } from './auth-crypto/auth-crypto-request-options';
// import {NbAuthJWTInterceptor} from '@nebular/auth-crypto';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NB_AUTH_TOKEN_CLASS, NbAuthJWTToken } from '@nebular/auth';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CheckboxEditorComponent } from 'ng2-smart-table/components/cell/cell-editors/checkbox-editor.component';
import { SelectEditorComponent } from 'ng2-smart-table/components/cell/cell-editors/select-editor.component';
import { TextareaEditorComponent } from 'ng2-smart-table/components/cell/cell-editors/textarea-editor.component';
import { CellModule } from 'ng2-smart-table/components/cell/cell.module';
import { CoreModule } from './@core/core.module';
import { AppInitService } from './@core/services/app-init.service';
import { CompanyDataService } from './@core/services/company-data.service';
import { ThemeModule } from './@theme/theme.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuardCrypto } from './pages-crypto/auth-crypto/auth-guard-crypto.service';
import { AuthInterceptorCrypto } from './pages-crypto/auth-crypto/auth-interceptor-crypto.service';
import { AuthProviderCrypto } from './pages-crypto/auth-crypto/auth-provider-crypto';
import { ForgotPasswordMessageCryptoComponent } from './pages-crypto/components-crypto/forgot-password-message-crypto/forgot-password-message-crypto.component';
import { RegistrationMessageCryptoComponent } from './pages-crypto/components-crypto/registration-message-crypto/registration-message-crypto.component';
import { ResetPasswordMessageCryptoComponent } from './pages-crypto/components-crypto/reset-password-message-crypto/reset-password-message-crypto.component';
import { Globals } from './pages-crypto/globals';
import { BooleanRenderComponent } from './pages-crypto/renderer-crypto/boolean-renderer';
import { ButtonViewComponent } from './pages-crypto/renderer-crypto/button-renderer-crypto';
import { CompletedRenderComponent } from './pages-crypto/renderer-crypto/completed-renderer';
import { DetailRendererCrypto } from './pages-crypto/renderer-crypto/detail-renderer-crypto';
import { DownloadConfirmationRendererCrypto } from './pages-crypto/renderer-crypto/download-confirmation-renderer-crypto';
import { DownloadRendererCrypto } from './pages-crypto/renderer-crypto/download-renderer-crypto';
import { EmvoCreatePackRendererCrypto } from './pages-crypto/renderer-crypto/emvo-create-pack-renderer-crypto';
import { PasswordRenderComponent } from './pages-crypto/renderer-crypto/password-renderer';

@NgModule({
  declarations: [ AppComponent,
    ForgotPasswordMessageCryptoComponent,
    ResetPasswordMessageCryptoComponent,
    RegistrationMessageCryptoComponent,
    BooleanRenderComponent,
    PasswordRenderComponent,
    CompletedRenderComponent,
    ButtonViewComponent,
    DownloadRendererCrypto,
    DownloadConfirmationRendererCrypto,
    EmvoCreatePackRendererCrypto,
    DetailRendererCrypto],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CellModule,

    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
  ],
  bootstrap: [ AppComponent ],
  entryComponents: [ CheckboxEditorComponent,
    SelectEditorComponent,
    TextareaEditorComponent,
    BooleanRenderComponent,
    PasswordRenderComponent,
    CompletedRenderComponent,
    ButtonViewComponent,
    DownloadRendererCrypto,
    DownloadConfirmationRendererCrypto,
    EmvoCreatePackRendererCrypto,
    DetailRendererCrypto],
  providers: [
    Globals,
    { provide: APP_BASE_HREF, useValue: '/' },
    // {
    //   // https://medium.com/@amcdnl/authentication-in-angular-jwt-c1067495c5e0
    //   provide: ErrorHandler,
    //   useClass: AuthErrorHandler
    // },
    // {
    //   // https://medium.com/@amcdnl/authentication-in-angular-jwt-c1067495c5e0
    //   provide: RequestOptions,
    //   useClass: AuthRequestOptions
    // },
    AuthProviderCrypto,
    AuthGuardCrypto, // OAuth2 Security - https://akveo.github.io/nebular/#/docs/auth/protecting-application-routes
    // { provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true }, // https://github.com/akveo/nebular/blob/master/src/app/app.module.ts
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorCrypto, multi: true }, // https://developer.okta.com/blog/2017/12/04/basic-crud-angular-and-spring-boot
    { provide: NB_AUTH_TOKEN_CLASS, useValue: NbAuthJWTToken },
    CompanyDataService,
    AppInitService,
  ],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts